export default {
  darkest: "#C9283E",
  dark: "#FF9E41",
  normal: "#FF9E41",
  normalWithAlpha: "#FF9E4155",
  light: "#C9283E",
  lightest: "#F0433A",
  backgroundTop: "#2E112D",
  backgroundBottom: "#C9283E",
  shadow: "#26132b2e",
  key: "Sunset Theme"
};



// WEBPACK FOOTER //
// ./src/utils/theme.sunset.js